import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { QtHistory } from './trainingCommon';
import { TrainingFunctions } from '../functions/trainingFunctions';
import { HrEmployees } from '../../../../models';
import { AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTableHeaderType } from '@aims/common-components';
import { TrainingBaseComponent } from './training-base.component';
import { RevokeApprovalCommentDialogComponent } from './revoke-approval-comment-dialog/revoke-approval-comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CompletedTrainingDialogComponent } from './completed-training-dialog/completed-training-dialog.component';
import { RevokeCommentDialogComponent } from './revoke-comment-dialog/revoke-comment-dialog.component';


@Component({
  selector: 'employeeTraining',
  templateUrl: './training.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TrainingFunctions]
})

export class EmployeeTrainingComponent extends TrainingBaseComponent {

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService,
    private dialog: MatDialog,
    public tFunc: TrainingFunctions) {
      super();
  }

  ALL_TRAINING = 0;
  INDIVIDUALLY_ASSIGNED = 1;
  GENERAL = 2;
  JOB_TITLE = 3;
  EMP_JOB_ASSIGNMENT = 4;
  OTHER_JOB_TITLE = 5;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  showIndAssigned: boolean = false;
  showGenAssigned: boolean = false;
  showJtAssigned: boolean = false;
  showOjtAssigned: boolean = false;
  showJaAssigned: boolean = false;

  isSelfTrained: boolean = false;
  isActiveAndEOAOnly: boolean = true;
  hasJtRequirements: boolean = false;
  countOccs: number = 0;

  headerText: string = 'Employee Training';
  routedFrom: string = 'employeeTraining';
  isMyTraining: boolean = true;

  trainerLookupColumns:AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Trainer', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active?', type:AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  //Dropdowns
  departmentValues = this.transferHttp.getSingle('Common/GetAllDepartmentsForDropdown');
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  activeEmployeeValues = this.transferHttp.getCache(CacheItem.activeEmployees);
  workSectionValues = this.transferHttp.getSingle('Common/GetAllWorksectionsForDropdown');
  jobTitleValues = this.transferHttp.getSingle('Common/GetAllJobTitlesForDropdown');
  jobAssignmentValues = this.transferHttp.getSingle('Common/GetAllEmployeeJobAssignmentsForDropdown');
  siteValues = this.transferHttp.getCache(CacheItem.sites);

  qualTaskTrainerValues = this.transferHttp.getSingle('Tr/GetQualTaskTrainers');
  qualValues = this.transferHttp.getSingle('Tr/GetQualsForDropDown');
  qualTaskValues = this.transferHttp.getSingle('Tr/GetQualTasksForDropDown');
  trainerValues = this.transferHttp.getSingle(`Tr/GetTrainers`);

  //New Popup
  newQtHistory: QtHistory = new QtHistory;

  //***************************
  // Training Variables
  //***************************
  user = this.transferHttp.getCache<HrEmployees>('user');
  empId = this.user.employeeId;
  empFullName = this.user.fullName;
  today = new Date();

  //Field Values
  revokeCommentTxt: string = null;
  sendRevokeEmail: boolean = false;

  revokeApprovalCommentTxt: string = null;
  sendRevokeApprovalEmail: boolean = false;


  //Revoke values
  qId: number = 0;
  qthId: number = 0;
  qthDesc: string = null;

  qualSource: number = this.ALL_TRAINING;

  loginName: string = null;

  qhId: number = 0;
  qhDesc: string = null;

  empForTraining: HrEmployees = new HrEmployees();

  //Grid config
  indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
  generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
  jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
  otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
  jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);

  allQttValues = [];
  filteredQttValues = [];

  allActiveEmpValues = [];
  filteredEmpValues = [];

  allQualTaskValues = [];

  public printAllHistory(empId: number) {
    this.router.navigate([`reporting/TR_AllTrainingHistoryByEmp/trdp/{"empID":"${empId}"}`]);
  }
  public printCurrentHistory(empId: number) {
    this.router.navigate([`reporting/TR_CurrentTrainingHistoryByEmp/trdp/{"empID":"${empId}"}`]);
  }

  public printOccJobTitleHistory(empId: number) {
    this.router.navigate([`reporting/TR_TrainingHistoryByEmpAndOcc/trdp/{"empID":"${empId}"}`]);
  }

  public printMyOverdueOrComingDueTraining(empId: number) {
    this.router.navigate([`reporting/TR_MyOverdueOrComingDueTraining/trdp/{"empID":"${empId}"}`]);
  }

  public getQualTaskDescription(qualTaskId: number): string {
    return this.allQualTaskValues.filter(qt => qt.qualTaskId == qualTaskId).map(qt => qt.description)[0];
  }

  public empTrainingReview(empId: number): void {
    this.empId = empId;
    if (empId == this.user.employeeId) {
      this.isMyTraining = true;
    } else {
      this.isMyTraining = false;
    }
    this.getTraineeEmpInfo();
    this.refreshTraining(this.ALL_TRAINING);
    this.checkExsits();
  }

  public getTraineeEmpInfo() {
    this.transferHttp.getHot(`Tr/GetEmployeeDetailForTraining?empId=${this.empId}`).subscribe(emp => {
      this.empForTraining = emp;
    });
    this.empFullName = this.empForTraining.fullName;
    this.loginName = this.empForTraining.loginName;
  }

  public checkExsits(): void {
    this.indAssignedTraining.subscribe(result => {
      if (result.length == 0) {
        this.showIndAssigned = false;
      }
      else {
        this.showIndAssigned = true;
      }
    });

    this.generalTraining.subscribe(result => {
      if (result.length == 0) {
        this.showGenAssigned = false;
      }
      else {
        this.showGenAssigned = true;
      }
    });

    this.jobTitleTraining.subscribe(result => {
      if (result.length == 0) {
        this.showJtAssigned = false;
      }
      else {
        this.showJtAssigned = true;
      }
    });

    this.otherJobTitleTraining.subscribe(result => {
      this.countOccs = result.length;

      if (this.countOccs == 0) {
        this.hasJtRequirements = false;
        this.showOjtAssigned = false;
      }
      else {
        this.hasJtRequirements = true;
        this.showOjtAssigned = true;
      }
    });

    this.jobAssignmentTraining.subscribe(result => {
      if (result.length == 0) {
        this.showJaAssigned = false;
      }
      else {
        this.showJaAssigned = true;
      }
    });

  }

  public handleActiveAndEOAOnlyChecked() {
    if (this.isActiveAndEOAOnly) {
      this.employeeValues = this.transferHttp.getCache(CacheItem.activeEmployees);
    }
    else {
      this.employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
    }
  }


  public updateTraining(masterQtHs: any, qualSource: number) {
    this.qualSource = qualSource;

    this.newQtHistory = new QtHistory();

    this.newQtHistory.qualTaskId = masterQtHs.qualTaskId;
    this.newQtHistory.employeeId = this.empForTraining.employeeId;
    this.newQtHistory.revoked = false;

    this.filteredQttValues = this.allQttValues.filter(qqt => qqt.qualTaskId == this.newQtHistory.qualTaskId && qqt.active);

    if (this.filteredQttValues.length <= 0) {
      this.isSelfTrained = true;
      this.newQtHistory.trainedById = this.empId;
    }

    this.newQtHistory.qtHistoryId = masterQtHs.qtHistoryId;

  const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: '',
        content: CompletedTrainingDialogComponent,
        contentData: { newQtHistory: this.newQtHistory,
                       isSelfTrained: this.isSelfTrained,
                       filteredQttValues: this.filteredQttValues, employeeValues: this.employeeValues                 },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.newQtHistory.completedOn = dialogResult.completedOn;
        if (!this.isSelfTrained ) {
          this.newQtHistory.trainedById = dialogResult.trainedById;
        }

        if (this.newQtHistory.completedOn != null && this.newQtHistory.trainedById != null) {
          this.saveNewQtHistory(this.newQtHistory);
        }
      }
      else {
        this.cancelNewQtHistory();
      }
    });
  }

  public cancelNewQtHistory(): void {
    this.isSelfTrained = false;
  }

  public saveNewQtHistory(newQtHistory: QtHistory): void {
    this.spinnerText = "Saving Qual Task History...";
    this.showSpinner = true;

    this.filteredEmpValues = this.allActiveEmpValues.filter(e => e.employeeId == newQtHistory.trainedById);

    this.transferHttp.post(`Tr/SaveQualTaskHistory`, newQtHistory).subscribe(show => {
      this.refreshTraining(this.qualSource);
      this.showSpinner = false;
    });

  }

  //Revoke Comment
  public openRevokeComment(qtDetail: any, qualSource: number) {
    this.qualSource = qualSource;
    this.qId = qtDetail.qualId;
    this.qthId = qtDetail.qtHistory.qtHistoryId;
    this.qthDesc = qtDetail.qtDesc;
    this.loginName = this.empForTraining.loginName;
    this.revokeCommentTxt = null;
    this.sendRevokeEmail = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: '',
        content: RevokeCommentDialogComponent,
        contentData: { qthDesc : this.qthDesc,
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.revokeCommentTxt = dialogResult.revokeComment;
        this.sendRevokeEmail = dialogResult.sendRevokeEmail;

        this.doRevoke();
      }
      else {
        this.cancelRevokeComment();
      }
    });

  }

  public cancelRevokeComment() {
    this.sendRevokeEmail = false;
    this.revokeCommentTxt = null;
  }

  public doRevoke() {
    this.spinnerText = "Revoking Qual Task...";
    this.showSpinner = true;

    let today = new Date();
    let revokedOn = today.toDateString();
    let revokedBy = this.user.fullName;

    this.transferHttp.get(`Tr/RevokeTraining?qId=${this.qId}&qthId=${this.qthId}&revokedReason=${this.revokeCommentTxt}`).subscribe(retVal => {
      if (this.sendRevokeEmail) {
        this.transferHttp.get(`Tr/SendRevokeEmail?desc=${escape(this.qthDesc)}&revokedOn=${revokedOn}&revokedBy=${revokedBy}&revokedReason=${this.revokeCommentTxt}&loginName=${this.loginName}`).subscribe();
      }
      this.cancelRevokeComment();
      this.refreshTraining(this.qualSource);
      this.showSpinner = false;
    });
  }

  //Revoke Approval Comment
  public openRevokeApprovalComment(qual: any, qualSource: number) {
    this.qualSource = qualSource;
    this.qhId = qual.qualHistory[0].qualHistoryId;
    this.qhDesc = qual.qualDesc;
    this.loginName = this.empForTraining.loginName;
    this.revokeApprovalCommentTxt = null;
    this.sendRevokeApprovalEmail = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: '',
        content: RevokeApprovalCommentDialogComponent,
        contentData: { qhDesc : this.qhDesc,
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.revokeApprovalCommentTxt = dialogResult.revokeApprovalComment;
        this.sendRevokeApprovalEmail = dialogResult.sendRevokeApprovalEmail;

        this.doRevokeApproval();
      }
      else {
        this.cancelRevokeApprovalComment();
      }
    });

  }

  public cancelRevokeApprovalComment() {
    this.revokeApprovalCommentTxt = null;
  }

  public doRevokeApproval() {
    this.spinnerText = "Revoking Qual ...";
    this.showSpinner = true;

    let today = new Date();
    let revokedOn = today.toDateString();
    let revokedBy = this.user.fullName;

    this.transferHttp.get(`Tr/RevokeQualApproval?qualHistoryId=${this.qhId}`).subscribe(retVal => {
      if (this.sendRevokeApprovalEmail) {
        this.transferHttp.get(`Tr/SendRevokeApprovalEmail?desc=${escape(this.qhDesc)}&revokedOn=${revokedOn}&revokedBy=${revokedBy}&revokedReason=${this.revokeApprovalCommentTxt}&empId=${this.empId}`).subscribe();
      }
      this.cancelRevokeApprovalComment();
      this.refreshTraining(this.qualSource);
      this.showSpinner = false;
    });

  }

  public updateQualRequired(qual: any, qualSource: number) {
    this.spinnerText = "Updating Qual required...";
    this.showSpinner = true;

    if (qual.qualRequired) {
      this.transferHttp.post(`Tr/SaveQualNotRequired?qualId=${qual.qualId}&empId=${this.empId}`, null).subscribe(show => {
        this.refreshTraining(qualSource);
        this.showSpinner = false;
      });
    }
    else {
      this.transferHttp.delete(`Tr/DeleteQualNotRequired?qualId=${qual.qualId}&empId=${this.empId}`).subscribe(show => {
        this.refreshTraining(qualSource);
        this.showSpinner = false;
      });
    }
  }

  public updateQtRequired(qt: any, qualSource: number) {
    this.spinnerText = "Updating Qual Task required...";
    this.showSpinner = true;

    if (qt.qtRequired) {
      this.transferHttp.post(`Tr/SaveQtNotRequired?qualTaskId=${qt.qualTaskId}&empId=${this.empId}`, null).subscribe(show => {
        this.refreshTraining(qualSource);
        this.showSpinner = false;
      });
    }
    else {
      this.transferHttp.delete(`Tr/DeleteQtNotRequired?qualTaskId=${qt.qualTaskId}&empId=${this.empId}`).subscribe(show => {
        this.refreshTraining(qualSource);
        this.showSpinner = false;
      });
    }
  }

  public refreshTraining(qualSource: number) {

    if (qualSource == null || qualSource == this.ALL_TRAINING) {
      this.indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
      this.generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
      this.jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
      this.otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
      this.jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.INDIVIDUALLY_ASSIGNED) {
      this.indAssignedTraining = this.transferHttp.getHot(`Tr/GetIndAssignedTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.GENERAL) {
      this.generalTraining = this.transferHttp.getHot(`Tr/GetGeneralTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.JOB_TITLE) {
      this.jobTitleTraining = this.transferHttp.getHot(`Tr/GetJobTitleTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.OTHER_JOB_TITLE) {
      this.otherJobTitleTraining = this.transferHttp.getHot(`Tr/GetOtherJobTitleTraining?empId=${this.empId}`);
    }
    else if (qualSource == this.EMP_JOB_ASSIGNMENT) {
      this.jobAssignmentTraining = this.transferHttp.getHot(`Tr/GetJobAssignmentTraining?empId=${this.empId}`);
    }
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {

    this.checkExsits();
    this.getTraineeEmpInfo();

    this.departmentValues.subscribe();
    this.workSectionValues.subscribe();
    this.jobTitleValues.subscribe();
    this.jobAssignmentValues.subscribe();


    this.qualTaskTrainerValues.subscribe(data => { this.allQttValues = data; });
    this.qualValues.subscribe();
    this.qualTaskValues.subscribe(data => { this.allQualTaskValues = data; });
    this.trainerValues.subscribe();
    this.handleActiveAndEOAOnlyChecked();

  }
}
